// extracted by mini-css-extract-plugin
export default {"container":"unmount-with-transition_container__gHVzW"};